{
  "help": "Ajuda",
  "info": "Informação"
}
